module.exports = __webpack_public_path__ + "static/dome-fd32a9814bb67a97379e0b38fd338565.png";